import React, { useMemo } from 'react'
import { Card, CardContent, CardTitle, CardDescription } from '../ui/Card'

const AffiliateOfferCards = ({ affiliateOffers = [] }) => {
  const memoizedCards = useMemo(() => {
    if (!affiliateOffers || affiliateOffers.length === 0) {
      return null
    }

    return affiliateOffers.map(offer => (
      <div key={offer.id} className='row' style={{ marginBottom: '2rem' }}>
        <div className='col'>
          <a
            href={offer.target_url}
            className='text-decoration-none'
            target='_blank'
            rel='noopener noreferrer'
            style={{ display: 'block' }}
          >
            <Card
              style={{
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-5px) scale(1.02)'
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)'
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0) scale(1)'
                e.currentTarget.style.boxShadow = ''
              }}
            >
              <CardContent>
                <CardTitle>
                  <h2 className='text-dark'>{offer.title}</h2>
                </CardTitle>
                <CardDescription className='d-flex flex-column gap-2'>
                  <span>
                    {offer.logo_url && (
                      <div className='mb-5'>
                        <img
                          src={offer.logo_url}
                          alt={`${offer.title} logo`}
                          className='img-fluid affiliate-offer-logo'
                          style={{
                            objectFit: 'contain',
                          }}
                        />
                      </div>
                    )}
                    <p className='mb-4 text-dark fs-5'>{offer.description}</p>
                    {(offer.deal_text || offer.button_text) && (
                      <p className='text-primary mb-0 mt-2 fs-5'>
                        {offer.deal_text || offer.button_text}
                      </p>
                    )}
                  </span>
                </CardDescription>
              </CardContent>
            </Card>
          </a>
        </div>
      </div>
    ))
  }, [affiliateOffers])

  return <>{memoizedCards}</>
}

export default AffiliateOfferCards
